import { render, staticRenderFns } from "./BlockFeaturedVideoSectionAwards.vue?vue&type=template&id=0630091c&scoped=true&"
import script from "./BlockFeaturedVideoSectionAwards.vue?vue&type=script&lang=js&"
export * from "./BlockFeaturedVideoSectionAwards.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeaturedVideoSectionAwards.vue?vue&type=style&index=0&id=0630091c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630091c",
  null
  
)

export default component.exports